<template>
<v-row class="login">
    <!-- NOTIFICATIONS -->
    <BaseNotification></BaseNotification>

    <v-col cols="12" lg="7" xl="6" class="info d-none d-md-flex align-center justify-center">
        <v-container>
            <div class="pa-10">
                <v-row justify="center">
                    <v-col cols="8" xl="5">
                        <div>
                            <h2 class="display-1 white--text font-weight-medium">Banca Única</h2>
                            <h6 class="subtitle-1 mt-4 white--text op-5 font-weight-regular">A plataforma mais rápida, fácil e segura do mercado.</h6>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-col>

    <v-col cols="12" lg="5" xl="6" class="d-flex align-center">
        <v-container>
            <div class="pa-7 pa-sm-12">
                <v-row>
                    <v-col cols="12" lg="9" xl="6">
                        <div align="center">
                            <v-img src="@/assets/images/logo-brasao.png" height="150" width="150" />
                        </div>
                        <h2 class="font-weight-bold mt-4 blue-grey--text text--darken-2" align="center">Acesse sua Conta</h2>

                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-text-field v-model="login" :rules="login_rules" label="Usuário" class="mt-4" required outlined></v-text-field>

                            <v-text-field v-model="password" :rules="passwordRules" label="Senha" required outlined :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" @keypress.enter="submit"></v-text-field>

                            <v-btn :loading="loading" :disabled="!valid || loading" color="info" block class="mr-4" submit @click="submit">
                                ENTRAR
                            </v-btn>
                        </v-form>
                    </v-col>
                </v-row>
            </div>
        </v-container>
    </v-col>
</v-row>
</template>

<script>
import {
    getUnixTime
} from "date-fns";

export default {
    name: "Login",

    data: () => ({
        valid: false,
        password: "",
        snackbar: {},
        access_token: "",
        show1: false,
        passwordRules: [v => !!v || "A senha é obrigatória."],
        login_rules: [v => !!v || "O usuário é obrigatório."],
        login: "",
        user_logged: {},
        loading: false,
        type: [
            {
                name: "master",
                value: "master"
            },
            {
                name: "admin_region",
                value: "admin_regiao"
            },
            {
                name: "sub_admin",
                value: "sub_admin"
            },
            {
                name: "auxiliar",
                value: "auxiliar"
            },
            {
                name: "manager",
                value: "gerente"
            },
            {
                name: "operator",
                value: "operador"
            },
        ],
    }),

    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true;

                this.$api
                    .post("/auth/login", {
                        username: this.login,
                        password: this.password
                    })
                    .then(response => {
                        // GETTING LOGIN INFO
                        this.access_token = response.data.access_token;
                        let expire_date = getUnixTime(new Date);
                        expire_date += response.data.expires_in - 300;

                        this.$api
                            .get("/auth/me", {
                                headers: {
                                    Authorization: `Bearer ${this.access_token}`
                                }
                            })
                            .then(response => {
                                this.user_logged = response.data;

                                localStorage.user = JSON.stringify(this.user_logged);

                                // SELLERS CAN'T ACESS THE SYSTEM 
                                if (this.user_logged.type == "cambista" || this.user_logged.type == "operador") {

                                    localStorage.isLogged = false;

                                    this.snackbar.text = "Usuário não autorizado!";
                                    this.snackbar.type = "error";
                                    this.snackbarShow(this.snackbar);

                                    return;
                                }

                                // KEEPING IN LOCAL STORAGE
                                localStorage.expire = expire_date;
                                localStorage.isLogged = true;

                                // KEEPING IN VUEX 
                                this.$store.dispatch("setLogged", {
                                    isLogged: true,
                                    user: this.user_logged,
                                    token: this.access_token,
                                    expire: expire_date
                                });

                                if(this.user_logged.type == "gerente" || this.user_logged.type == "sub_admin" || this.user_logged.type == "auxiliar") {
                                    return this.$router.push({
                                        path: `/${this.type[this.type.findIndex(user => user.value == this.user_logged.type)].name}/profile`
                                    });
                                }

                                // PUSH TO DASHBOARD ROUTER
                                this.$router.push({
                                    path: `/${this.type[this.type.findIndex(user => user.value == this.user_logged.type)].name}/dashboard`
                                });

                            })
                            .catch(() => {
                                this.snackbar.text = "Não foi possível carregar os dados.";
                                this.snackbar.type = "warning";
                                this.snackbarShow(this.snackbar);

                                this.loading = false;
                            });

                        return;
                    })

                    .catch(() => {
                        this.snackbar.text = "Verifique os dados novamente!";
                        this.snackbar.type = "error";
                        this.snackbarShow(this.snackbar);

                        this.loading = false;
                    });
            }
        },
    }
};
</script>

<style>

.login .theme--light.v-select .v-select__selection--comma,
.login .theme--light.v-input input, 
.login .theme--light.v-label,
.login .theme--light.v-icon {
    color: #000;
}

.v-autocomplete.v-input > .v-input__control > .v-input__slot {
    cursor: pointer;
}

</style>
